export default function formatCombatConfirmationMessage({ round, event } = {}) {
  const roundNumber = Number(round)

  if (!Number.isFinite(roundNumber) || roundNumber <= 0 || !event) {
    return ''
  }

  return `Round ${roundNumber} - ${event} confirmed`
}
